import { render, staticRenderFns } from "./EventStatusBall.vue?vue&type=template&id=4b053150&"
import script from "./EventStatusBall.vue?vue&type=script&lang=js&"
export * from "./EventStatusBall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports